import React from "react";
import {
  AbilityWrapper,
  AbilityVotingCards,
  AbilityText,
  PhaseTag,
  InformationText,
} from "../styles/Game.styles";
import VotingCard from "./VotingCard";
import { joinWithAnd } from "../utils/gameUi";
import { Header } from "../../../styleguide/atoms/index";

export default function DayActions({
  me,
  isDay,
  dayDone,
  dayTotal,
  iAmSilenced,
  myDayVote,
  dayVoteOptions,
  onDayVote,
  dayBlocked,
  blockedNames,
  silenced,
  silencedNames,
  dayVoteLimit,
  debateStatus,
  debateCount = 0,
  cheerMessages = [],
  timeLeftMs,
}) {
  const limited = Array.isArray(dayVoteLimit) && dayVoteLimit.length > 0;
  const finalOptions = limited
    ? dayVoteOptions.filter((p) => dayVoteLimit.includes(p.id))
    : dayVoteOptions;

  const noValidTargets = limited && finalOptions.length === 0;
  const cantVoteReason = iAmSilenced
    ? "silenced"
    : noValidTargets
    ? "noTargets"
    : null;

  // Loading state for any click within this block
  const [submitting, setSubmitting] = React.useState(false);
  const [pendingKey, setPendingKey] = React.useState(null);
  const wrap =
    (fn, key) =>
    async (...args) => {
      if (submitting) return;
      setSubmitting(true);
      setPendingKey(key);
      try {
        await fn(...args);
      } catch (e) {
        console.error(e);
      } finally {
        setSubmitting(false);
        setPendingKey(null);
      }
    };

  const clickVote = (id) => wrap(onDayVote, `day:${id ?? "skip"}`)(id);
  const isAlive = me?.alive !== false;
  return (
    <>
      <PhaseTag $isDay={isDay}>Day</PhaseTag>
      <InformationText>
        Progress:{" "}
        <b>
          {dayDone} / {dayTotal}
        </b>{" "}
        voted
      </InformationText>
      <Header type="h3" align="center">
        {timeLeftMs == null
          ? ""
          : Math.max(0, Math.ceil(timeLeftMs / 1000)) + "s"}
      </Header>

      {isAlive ? (
        <AbilityWrapper>
          {cantVoteReason === "noTargets" && (
            <AbilityText>
              You can’t vote this round because the available targets don’t
              include anyone you can select.
            </AbilityText>
          )}

          {dayBlocked.size > 0 && (
            <AbilityText>
              {blockedNames.length === 1
                ? `The Skater has removed ${blockedNames[0]} from this round of voting.`
                : `The Skaters have removed ${joinWithAnd(
                    blockedNames
                  )} from this round of voting.`}
            </AbilityText>
          )}

          {silenced.size > 0 && (
            <AbilityText>
              {silencedNames.length === 1
                ? `The Punk has silenced ${silencedNames[0]} from voting this round.`
                : `The Punks have silenced ${joinWithAnd(
                    silencedNames
                  )} from voting this round.`}
            </AbilityText>
          )}

          {cheerMessages.length > 0 &&
            cheerMessages.map((msg, i) => (
              <AbilityText key={i}>{msg}</AbilityText>
            ))}

          {cantVoteReason ? (
            <AbilityText>
              {cantVoteReason === "silenced"
                ? "You have been silenced and cannot vote this round."
                : "You can’t vote this round because the available targets don’t include anyone you can select."}
            </AbilityText>
          ) : (
            <>
              {debateStatus === "applied" && (
                <AbilityText>
                  {debateCount > 1
                    ? "The Debate Students have narrowed down the vote!"
                    : "The Debate Student narrowed down the vote!"}
                </AbilityText>
              )}
              <AbilityText>Select someone to eliminate.</AbilityText>
              <AbilityVotingCards>
                {!limited && (
                  <VotingCard
                    selected={myDayVote === null}
                    disabled={submitting}
                    loading={submitting && pendingKey === "day:skip"}
                    onClick={() => clickVote(null)}
                  >
                    Skip
                  </VotingCard>
                )}
                {finalOptions.map((p) => (
                  <VotingCard
                    key={p.id}
                    selected={myDayVote === p.id}
                    disabled={submitting}
                    loading={submitting && pendingKey === `day:${p.id}`}
                    onClick={() => clickVote(p.id)}
                  >
                    {p.name}
                  </VotingCard>
                ))}
              </AbilityVotingCards>
            </>
          )}
        </AbilityWrapper>
      ) : null}
    </>
  );
}
